export default __webpack_public_path__ + "static/media/alert.f282a540.svg";